import { runtimeConfig } from "../config/runtime-config";

// Куда уходят падения фронтенда.
//
// Раньше — никуда: у человека белый экран, в мониторинге тишина, и узнать об
// этом можно было только от него самого. Отчёт уходит на свой же origin, а
// пересылает его дальше сервер: адрес и токен приёмника не должны лежать в
// бандле, который отдаётся всем.
//
// Уезжает только форма сбоя — сообщение, стек, путь страницы и версия сборки.
// Ни значений полей, ни query-строки: отчёт об ошибке не должен становиться
// боковым каналом для данных, на которых она произошла.
type ClientErrorReport = {
  context: string;
  message: string;
  release: string;
  stack?: string;
  url: string;
};

const endpoint = "/client-errors";
// Один и тот же сбой в рендере повторяется каждый кадр; отправлять его столько
// же раз — значит утопить мониторинг в одной строке.
const reported = new Set<string>();
const maxReportsPerSession = 20;

export function reportClientError(error: unknown, context: string): void {
  const message = error instanceof Error ? error.message : String(error);
  if (!message) return;

  const fingerprint = `${context}:${message}`;
  if (reported.has(fingerprint) || reported.size >= maxReportsPerSession) return;
  reported.add(fingerprint);

  const report: ClientErrorReport = {
    context,
    message: message.slice(0, 1000),
    release: runtimeConfig.release,
    ...(error instanceof Error && error.stack ? { stack: error.stack.slice(0, 4000) } : {}),
    url: window.location.pathname,
  };

  // keepalive: сбой часто случается ровно тогда, когда страницу закрывают или
  // перезагружают, и обычный fetch не успевает уйти.
  void fetch(endpoint, {
    body: JSON.stringify(report),
    headers: { "content-type": "application/json" },
    keepalive: true,
    method: "POST",
  }).catch(() => {
    // Мониторинг не должен быть тем, из-за чего ломается страница.
  });
}

// Всё, что не поймал ни один ErrorBoundary: ошибки вне React и отвалившиеся
// промисы.
export function installClientErrorHandlers(): void {
  window.addEventListener("error", (event) => {
    reportClientError(event.error ?? event.message, "window");
  });
  window.addEventListener("unhandledrejection", (event) => {
    reportClientError(event.reason, "unhandledRejection");
  });
}
